import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
import Paper from "@mui/material/Paper";
import TextField from "@mui/material/TextField";
import FormHelperText from "@mui/material/FormHelperText";
import { useFormikContext } from "formik";
import Image from "../../../../components/capture/ReceivingWizard/Image";
import Input from "../../../../components/form/Input";
import ImageUploadButtons from "../../../../views/capture/Images/ImageUploadButtons";

export default function OSAndDDetailsForm({ osd, onUpload, onRemoveImage, onUpdateImage }) {
  const { errors } = useFormikContext();
  const hasImageError = !!errors.osdImage;

  return (
    <>
      <Paper>
        <Box p={2}>
          <Grid container spacing={1}>
            <Grid size={12}>
              <Typography pb={1} fontWeight={500}>
                OS&D Images
              </Typography>
              <Image
                images={osd?.attachments || []}
                onUpload={onUpload}
                onRemove={onRemoveImage}
                onUpdate={onUpdateImage}
                helperText="Add pictures here to show the damage, missing items, or other issues you’re reporting"
              />
            </Grid>
            <Grid size={12}>
              <Box px={{ md: 5, xs: 2 }} display="flex" justifyContent="center">
                <Box width="100%" maxWidth={400}>
                  <ImageUploadButtons
                    onUpload={e => onUpload(e.target.files)}
                    hasError={hasImageError}
                    idPrefix="osd"
                  />

                  {hasImageError && (
                    <Box mt={1} display="flex" justifyContent="center">
                      <FormHelperText error>{errors.osdImage}</FormHelperText>
                    </Box>
                  )}
                </Box>
              </Box>
            </Grid>
          </Grid>
        </Box>
      </Paper>
      <Paper sx={{ mt: 2 }}>
        <Box p={2}>
          <Grid container spacing={1}>
            <Grid size={12}>
              <Typography pb={1} fontWeight={500}>
                OS&D Info
              </Typography>
            </Grid>
            <Grid size={12}>
              <TextField
                fullWidth
                disabled
                size="small"
                label="Item ID"
                value={osd?.shipmentItem?.asset?.itemId}
              />
            </Grid>
            <Grid size={12}>
              <TextField
                fullWidth
                disabled
                size="small"
                label="Description"
                value={osd?.shipmentItem?.asset?.description}
              />
            </Grid>
            <Grid size={12}>
              <TextField
                fullWidth
                disabled
                size="small"
                label="Quantity Received"
                value={osd?.shipmentItem?.quantity}
              />
            </Grid>
            <Grid size={12}>
              <Input
                type="number"
                name="osdQuantity"
                label="Impacted Quantity"
                showNAButton={false}
              />
            </Grid>
            <Grid size={12}>
              <Input multiline rows={4} name="osdNotes" label="OS&D Notes" showNAButton={false} />
            </Grid>
          </Grid>
        </Box>
      </Paper>
    </>
  );
}
